import { Component, Input } from '@angular/core';
import { BulkScrapSource, BulkScrapStatus } from '../../services/bulk-scrap-request.service';
import { BULK_SCRAP_SOURCE_META, BULK_SCRAP_STATUS_META } from './bulk-scrap-display';

@Component({
  selector: 'app-bulk-scrap-status-badge',
  standalone: true,
  template: `<span
    [class]="meta.badgeClass"
    class="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold border whitespace-nowrap"
    >{{ meta.label }}</span
  >`,
})
export class BulkScrapStatusBadgeComponent {
  @Input({ required: true }) status!: BulkScrapStatus;

  get meta() {
    return BULK_SCRAP_STATUS_META[this.status];
  }
}

@Component({
  selector: 'app-bulk-scrap-source-badge',
  standalone: true,
  template: `<span
    [class]="meta.badgeClass"
    class="inline-block px-2 py-0.5 rounded text-[11px] font-semibold uppercase tracking-wider"
    >{{ meta.label }}</span
  >`,
})
export class BulkScrapSourceBadgeComponent {
  @Input({ required: true }) source!: BulkScrapSource;

  get meta() {
    return BULK_SCRAP_SOURCE_META[this.source];
  }
}
